import { IFindExcursionsFilter } from 'entities/excursions/models/find-excursions/models'

import { clientApi } from 'shared/api/clientApi'
import { Pagination, Response } from 'shared/models/general'

import { IExcursionDetails, IFindExcursionsList } from './model'

interface ResponseFindExcursions
  extends Pagination, Response<IFindExcursionsList> {}

export const ExcursionsList = {
  getExcursionsList(params: IFindExcursionsFilter | undefined, page: number) {
    return clientApi.post<ResponseFindExcursions>(
      `/excursions/list?page=${page}`,
      params,
    )
  },

  getExcursionById(id: string | undefined) {
    return clientApi.get<Response<IExcursionDetails>>(`/excursions/${id}`)
  },
}
